import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getName } from '../../helpers/Crew';

const DialogEpisode = ({ episode }) => {
	const { t } = useTranslation();

	if (!episode) return null;

	return <>
		<div>
			{episode.event.title}
		</div>
		<div>
			{t('episodes.startTime', { date: new Date(episode.start) })}
		</div>
		<div>
			{episode.players.map(p => getName(p)).join(', ')}
		</div>
	</>;
};

DialogEpisode.propTypes = {
	episode: PropTypes.shape({
		event: PropTypes.shape({
			title: PropTypes.string,
		}),
		players: PropTypes.arrayOf(PropTypes.shape({
		})),
		start: PropTypes.string,
	}),
};

export default DialogEpisode;
